import React from 'react';

interface AnalyticsData {
    nutrition_itog: number;
    trainings_itog: number;
    vitamins_itog: number;
    labels: string[];
    nutrition_data: number[];
    trainings_data: number[];
    vitamins_data: number[];
}

interface ResultsPageProps {
    month: string;
    analyticsData: AnalyticsData;
}

export const ResultsPage: React.FC<ResultsPageProps> = ({ month, analyticsData }) => {
    const colors = {
        nutrition: 'medium',
        trainings: 'high',
        vitamins: 'very-high',
    };

    const labels = {
        nutrition: 'питанию',
        trainings: 'тренировкам',
        vitamins: 'витаминам',
    };

    const metrics: Array<keyof typeof labels> = ['nutrition', 'trainings', 'vitamins'];

    return (
        <main className="layout__content">
            <section className="section layout__section program results">
                <div className="container">
                    <header className="section__header program__header program-header">
                        {/* Навигация — при необходимости вставить */}
                        <div className="program-header__top program-header-top program-header-top_no-margin">
                            <div className="program-header-top__inner">
                                <div className="program-header-top__left">
                                    <h1 className="title section__title">Результаты</h1>
                                    <div className="program__time">
                                        <div className="program__time-badge">за {month} месяц</div>
                                    </div>
                                    <span className="program__label">Вы молодец, но можете лучше!</span>
                                </div>
                                <div className="program-header-top__right">
                                    {/* Профиль/подписка */}
                                </div>
                            </div>
                        </div>
                        <div className="program-header__bottom program-header-bottom">
                            <div className="program-header-bottom__inner">
                                <div className="program-header-bottom__left">
                                    <p className="program__note">
                                        И есть, над чем поработать. Посмотрите диаграммы — это аналитика ваших успехов.
                                    </p>
                                </div>
                                <div className="program-header-bottom__right">
                                    <p className="program__description">
                                        Важно соблюдать баланс и заботиться обо всех аспектах здоровья...
                                    </p>
                                </div>
                            </div>
                        </div>
                    </header>

                    <div className="section__content">
                        <div className="results__data results-data">
                            <div className="results-data__grid">
                                {metrics.map((metric) => (
                                    <div key={metric} className="results-data__col">
                                        <div className="results-data__item results-data-item">
                                            <div className="results-data-item__chart">
                                                <div className="pie-chart">
                                                    <div
                                                        className="pie-chart__inner"
                                                        style={{
                                                            ['--color' as any]: `var(--health-level-color-${colors[metric]})`,
                                                            ['--progress' as any]: `${analyticsData[`${metric}_itog` as keyof AnalyticsData]}%`,
                                                        }}
                                                    >
                                                        <div className="pie-chart__value">
                                                            {analyticsData[`${metric}_itog` as keyof AnalyticsData]}%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="results-data-item__info">
                                                <span className="results-data-item__label">
                                                    Выполнение плана по {labels[metric]}
                                                </span>
                                                <span className="results-data-item__period">за месяц</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {metrics.map((metric) => (
                                    <div key={`${metric}-chart`} className="results-data__col">
                                        <div className="results-data__item results-data-item">
                                            <div className="results-data-item__chart">
                                                {/* Вставить Chart.js или другой график здесь */}
                                            </div>
                                            <div className="results-data-item__info">
                                                <span className="results-data-item__label">
                                                    Выполнение плана по {labels[metric]}
                                                </span>
                                                <span className="results-data-item__period">по дням</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section layout__section next-program">
                <div className="container">
                    <div className="next-program__inner">
                            <img
                                className="next-program__image"
                                src="/img/intro-test-image.png"
                                alt="Лимоны в руке"
                            />
                        <div className="next-program__info">
                            <div className="next-program__title">
                                <h2>Новая программа от <strong>BionMax</strong></h2>
                                <span className="next-program__badge">на следующий месяц</span>
                            </div>
                            <div className="next-program__card">
                                <p className="next-program__text">
                                    Пройдите тест на оценку улучшения самочувствия и ваших достижений и получите программу по
                                    тренировкам, питанию и витаминам на новый месяц.
                                </p>
                                <div className="next-program__action">
                                    <a className="button button_outline" href="/online-check/passing-a-retest">
                                        Пройти тест
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </main>
    );
};
